<p-table
  #dt1
  [value]="machines"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]="loading"
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="true"
  currentPageReportTemplate="Prikaz od {first}. do {last}. mašine od ukupno {totalRecords}"
  [globalFilterFields]="['fname', 'lname', 'email', 'username']"
>
  <ng-template pTemplate="caption">
    <div class="page-control flex align-items-center">
      <div class="grid w-100">
        <div class="col-4 sm-4">
          <span class="p-input-icon-left w-100">
            <i class="pi pi-search"></i>
            <input
              pInputText
              class="w-100"
              type="text"
              (input)="dt1.filterGlobal($event.target.value, 'contains')"
              placeholder="Pretraži"
            />
          </span>
        </div>
      </div>

      <div class="btn-group">
        <a [routerLink]="['add']" class="main-btn add-new-btn"
          >Dodaj mašinu <i class="pi pi-plus"></i
        ></a>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th>
        <div class="flex justify-content-center align-items-center">Naziv</div>
      </th>
      <th>
        <div class="flex justify-content-center align-items-center">
          Operacije
        </div>
      </th>

      <th style="width: 8rem">
        <div class="flex align-items-center">Akcija</div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-machine>
    <tr>
      <td>
        <span class="image-text">{{ machine.name }} </span>
      </td>
      <td>
        <span
          class="badge mr-1"
          *ngFor="let operations of machine.operations"
          >{{ operations.name }}</span
        >
      </td>

      <td class="text-center">
        <ng-container *ngIf="!machine.deleted_at">
          <a
            class="second-btn small-btn mr-2"
            pTooltip="Izmeni"
            tooltipPosition="top"
            (click)="onEdit(machine)"
            [routerLink]="['edit']"
          >
            <i class="pi pi-pencil"></i>
          </a>
          <button
            class="second-btn small-btn"
            type="button"
            pTooltip="Izbriši"
            tooltipPosition="top"
            (click)="onDelete($event, machine.id)"
          >
            <i class="pi pi-trash"></i>
          </button>
        </ng-container>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6">Ni jedan korisnik nije pronađen.</td>
    </tr>
  </ng-template>
</p-table>
